export const GET_TRADED_FACILITIES = 'tradedfacilities/GET_TRADED_FACILITIES'
export const RESET_TRADED_FACILITIES =
  'tradedfacilities/RESET_FACILITY_TRADED_FACILITIES'
export const START_LOADING_TRADED_FACILITIES =
  'tradedfacilities/START_LOADING_TRADED_FACILITIES'
export const ADD_TRADED_FACILITY_FEE =
  'tradedfacilities/ADD_TRADED_FACILITY_FEE'
export const DELETE_TRADED_FACILITY_FEE =
  'tradedfacilities/DELETE_TRADED_FACILITY_FEE'
export const UPDATE_TRADED_FACILITY_FEE =
  'tradedfacilities/UPDATE_TRADED_FACILITY_FEE'
export const STOP_LOADING_TRADED_FACILITIES =
  'tradedfacilities/STOP_LOADING_TRADED_FACILITIES'
export const UPDATE_TRADE_FACILITY_AMOUNT =
  'tradedfacilities/UPDATE_TRADE_FACILITY_AMOUNT'
export const ADD_TEMPORARY_TRADE_FACILITY =
  'tradedfacilities/ADD_TEMPORARY_TRADE_FACILITY'
export const DELETE_TRADED_FACILITIES =
  'tradedfacilities/DELETE_TRADED_FACILITIES'
